import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, Phone, MapPin } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/leads", { type: "contact", ...form });
      toast.success("Message sent — we'll get back to you shortly.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch {
      toast.error("Could not send. Please try again.");
    } finally { setSubmitting(false); }
  };
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" data-testid="contact-page">
      <div className="grid lg:grid-cols-2 gap-16">
        <div>
          <div className="overline text-[#1a2d5e]">Contact</div>
          <h1 className="font-display font-black text-5xl mt-2 text-[#0b1838] tracking-tighter">Let's talk.</h1>
          <p className="mt-3 text-slate-600 max-w-md">Questions, custom orders, bulk purchase, partnership — drop us a line. We typically reply within a few hours.</p>
          <ul className="mt-8 space-y-5 text-slate-700">
            <li className="flex items-center gap-3"><Mail className="text-[#1a2d5e]" /> info@jas-computers-mobiles.co.uk</li>
            <li>
              <div className="overline text-[#1a2d5e]">Crieff</div>
              <div className="mt-1 flex items-center gap-3"><MapPin size={18} className="text-[#1a2d5e]" /> 60 High St, Crieff PH7 3BS</div>
              <div className="mt-1 flex items-center gap-3"><Phone size={18} className="text-[#1a2d5e]" /> <a href="tel:01764218483" className="hover:underline">01764 218483</a></div>
            </li>
            <li>
              <div className="overline text-[#1a2d5e]">Aberdeen</div>
              <div className="mt-1 flex items-start gap-3"><MapPin size={18} className="text-[#1a2d5e] mt-0.5" /> <span>Unit 3, East Mall Guild Square,<br/>Union Square Shopping Centre,<br/>Aberdeen AB11 5RA</span></div>
              <div className="mt-1 flex items-center gap-3"><Phone size={18} className="text-[#1a2d5e]" /> <a href="tel:07403535385" className="hover:underline">07403 535385</a></div>
            </li>
          </ul>
        </div>
        <form onSubmit={submit} className="bg-slate-50 border border-slate-200 rounded-2xl p-8" data-testid="contact-form">
          <div className="grid gap-4">
            <input required placeholder="Your name" data-testid="contact-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            <div className="grid sm:grid-cols-2 gap-3">
              <input required type="email" placeholder="Email" data-testid="contact-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
              <input placeholder="Phone (optional)" data-testid="contact-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            </div>
            <textarea required rows={5} placeholder="How can we help?" data-testid="contact-message" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="px-4 py-3 border border-slate-300 rounded-lg bg-white" />
            <button disabled={submitting} data-testid="contact-submit" type="submit" className="px-6 py-4 bg-[#1a2d5e] text-white font-semibold rounded-lg hover:bg-[#0b1838] transition-colors disabled:opacity-60">{submitting ? "Sending…" : "Send Message"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
